// 1-слоты,
// 2-ставки,
// 3-Быстрые,
// 4-Live дилер,
// 5-Настольные,
// 6-Избранное,
// 7-Казино,
// 9-Статус,
// 10-Кешбэк,
// 11-Бонусы,
// 12-Телеграм,
// 13-Промокоды
// 14-поддержка,
// 15-магазин,

// 16-меню,
// 17-игры,
// 18-поддержка,
// 19-профиль,
// 20-беттинг
// 21-беттинг sports
// 22-беттинг live
// 23-беттинг результаты
// 24-колесо фортуны
// 25-Лотерея
// 26-Кошелек
// 27-Поиск
// 28-Бонусы - нижнее мобильное меню
// 29-Home
// 30-pingWin-originals
// 31-Ребейт
// 32-Ежедневный бонус
// 33-Реферальная программа

import { brandIsPh } from '@/shared/config/brand-by-target.mjs';
import { getThemeBrand } from '@/shared/hooks/useBrandTheme';
import type { MiniBannerCounterKey } from '@/entities/minibanner/ui/counters';

export const BANNERS_DATA: Array<BannerData> = [
  {
    id: 1,
    image: '/images/icons/minibanners_new/slots.png',
    param: 'slots',
    tKey: 'mini_games_banners.slots',
  },
  {
    id: 2,
    image: '/images/icons/minibanners_new/bids.png',
    param: 'betting',
    tKey: 'common.footer.betting',
  },
  {
    id: 3,
    image: '/images/icons/minibanners_new/fast.png',
    param: 'instant',
    tKey: 'mini_games_banners.fast',
  },
  {
    id: 4,
    image: '/images/icons/minibanners_new/liveDealer.png',
    param: 'live',
    tKey: 'mini_games_banners.dealer',
  },
  {
    id: 5,
    image: '/images/icons/minibanners_new/desktop.png',
    param: 'table',
    tKey: 'mini_games_banners.table',
  },
  {
    id: 6,
    image: '/images/icons/minibanners_new/favourites.png',
    param: 'favorite',
    fullParam: 'games/favorite',
    tKey: 'mini_games_banners.wishlist',
    counter: 0,
    counterKey: 'wishlist',
  },
  {
    id: 7,
    image: '/images/icons/minibanners_new/casino.png',
    param: 'games',
    tKey: 'minibanners.games',
  },
  {
    id: 9,
    image: '/images/icons/minibanners_new/status.png',
    param: 'status',
    tKey: 'minibanners.status',
    counterKey: 'status',
  },
  {
    id: 10,
    image: '/images/icons/minibanners_new/cashback.png',
    param: 'cashback',
    tKey: 'minibanners.cashback',
    counterKey: 'cashback',
  },
  {
    id: 11,
    image: '/images/icons/minibanners_new/bonuses.png',
    param: 'bonuses',
    tKey: 'minibanners.bonus',
    counterKey: 'bonuses',
  },
  // {
  //   id: 12,
  //   image: '/images/icons/minibanners_new/telegram.png',
  //   param: 'https://t.me/pingwincasino',
  //   tKey: 'minibanners.telegram',
  // },
  {
    id: 13,
    image: '/images/icons/minibanners_new/promoCodes.png',
    param: 'promocodes',
    tKey: 'menu_banner.promo',
  },
  {
    id: 14,
    image: '/images/icons/minibanners_new/support.png',
    param: 'support',
    tKey: 'common.footer.support',
  },
  {
    id: 15,
    image: '/images/icons/minibanners_new/shop.png',
    param: 'store',
    tKey: 'menu_banner.shop',
    // disabled: true,
  },
  {
    id: 16,
    image: '/images/icons/menu_new/menu.svg',
    srcActive: '/images/icons/menu_new/menu_active.svg',
    param: 'menu',
    tKey: 'common.footer.menu',
  },
  {
    id: 17,
    image: '/images/icons/menu_new/games.svg',
    srcActive: '/images/icons/menu_new/games_active.svg',
    param: 'games',
    tKey: 'common.footer.games',
  },
  {
    id: 18,
    image: '/images/icons/menu_new/support.svg',
    srcActive: '/images/icons/menu_new/support_active.svg',
    param: 'support',
    tKey: 'common.footer.support',
  },
  {
    id: 19,
    image: brandIsPh
      ? '/images/icons/menu_new/account_ph.svg'
      : '/images/icons/menu_new/profile.png',
    // srcActive: '/images/icons/menu_new/profile_active.svg',
    param: 'profile',
    tKey: 'common.footer.profile',
  },
  {
    id: 20,
    image: '/images/icons/menu_new/sport.svg',
    srcActive: '/images/icons/menu_new/sport_active.svg',
    param: 'betting',
    tKey: 'common.footer.betting',
  },
  {
    id: 21,
    image: '/images/icons/minibanners_new/bets_sport.png',
    param: 'betting?page=sport',
    tKey: 'mini_games_banners.bets_sport',
  },
  {
    id: 22,
    image: '/images/icons/minibanners_new/bets_live.png',
    param: 'betting?page=live',
    tKey: 'mini_games_banners.bets_live',
  },
  {
    id: 23,
    image: '/images/icons/minibanners_new/bets_result.png',
    param: 'betting?page=results',
    tKey: 'mini_games_banners.bets_results',
  },
  {
    id: 24,
    image: '/images/icons/minibanners_new/fortune-wheel.png',
    param: 'fortune-wheel',
    tKey: 'minibanners.wheel',
    counterKey: 'wheel',
  },
  {
    id: 25,
    image: '/images/icons/minibanners_new/lottery.png',
    param: 'lottery',
    tKey: 'mini_games_banners.lottery',
  },
  {
    id: 26,
    image: '/images/icons/menu_new/wallet.svg',
    param: 'wallet',
    tKey: 'common.footer.wallet',
  },
  {
    id: 27,
    image: '/images/icons/menu_new/search.svg',
    param: 'search',
    tKey: 'wallet.search',
  },
  {
    id: 28,
    image: brandIsPh
      ? '/images/icons/menu_new/bonus_ph.svg'
      : '/images/icons/menu_new/bonus.svg',
    param: 'bonuses',
    tKey: 'common.footer.bonus',
  },
  {
    id: 29,
    image: brandIsPh ? '/images/icons/menu_new/home_ph.svg' : '',
    param: '',
    tKey: 'common.footer.home',
  },
  {
    id: 30,
    image: '/images/icons/minibanners_new/pingWin-originals.png',
    param: 'games?filter=exclusive',
    tKey: 'minibanners.pingWin_originals',
  },
  {
    id: 31,
    image: '/images/icons/minibanners_new/rebate.png',
    param: 'rebate',
    tKey: 'minibanners.rebate',
  },
  {
    id: 32,
    image: '/images/icons/minibanners_new/db.png',
    param: 'bonuses/daily',
    tKey: 'minibanners.db',
  },
  {
    id: 33,
    image: '/images/icons/minibanners_new/referral.png',
    param: 'referral',
    tKey: 'minibanners.referral',
  },
];

export const BANNERS_BY_ID = new Map<number, BannerData>();
for (const banner of BANNERS_DATA) {
  BANNERS_BY_ID.set(banner.id, banner);
}

export const SORT_CONFIG_BANNERS = {
  unauthenticated: {
    desktop: {
      main: [7, 30, 2, 11, 10, 9, 12, 13],
      games: [1, 25, 2, 3, 4, 5],
      betting: [21, 22, 23, 7, 11, 10, 9],
    },
    mobile: {
      main: [11, 30, 10, 9, 12],
      games: [1, 25, 2, 3, 4, 5],
      betting: [21, 22, 23, 11, 10, 9, 12],
    },
  },
  authenticated: {
    desktop: {
      main: [7, 6, 30, 32, 2, 11, 10, 9, 15, 24, 13, 12],
      games: [1, 25, 6, 2, 3, 4, 5],
      betting: [21, 22, 23, 7, 11, 10],
    },
    mobile: {
      main: [6, 30, 32, 11, 10, 9, 15, 24, 13, 12],
      games: [1, 25, 6, 2, 3, 4, 5],
      betting: [21, 22, 23, 7, 11, 10, 9, 24, 13, 12],
    },
  },
  mobileMenuModal: [7, 2, 9, 32, 33, 15, 24, 10, 11, 13, 6, 12, 14, 19],
  mobileMenu: [16, 17, 26, 28, 27],
  mobileMenuWithBetting: [16, 20, 26, 28, 27],
  // ph mobile bottom menu: Home, Menu, Депозит, Rewards, Account
  mobileMenuPh: [29, 16, 26, 28, 19],
  navInfoMenu: [29, 17, 2, 28, 9, 6],
  navBettingMenu: [21, 22, 23],
};
export const AUTH_ONLY_MENU_BANNERS = new Set([19, 33]);
export const PH_ONLY_BANNERS = new Set([32, 33]);
export const mobileMenuBanners = SORT_CONFIG_BANNERS.mobileMenu;
export const mobileMenuBannersWithBetting =
  SORT_CONFIG_BANNERS.mobileMenuWithBetting;
export const mobileMenuBannersPh = SORT_CONFIG_BANNERS.mobileMenuPh;

// ph mobile-only order: Казино, Дейли бонус, Ребейт, Реферальная программа, Колесо, Статус, Магазин, Промокоды / Слоты, Избранное, Быстрые, Live dealer, Настольные
export const SORT_CONFIG_BANNERS_PH_MOBILE = {
  unauthenticated: {
    main: [7, 32, 31, 9, 13],
    games: [1, 3, 4, 5],
  },
  authenticated: {
    main: [7, 6, 32, 31, 33, 24, 9, 15, 13],
    games: [1, 6, 3, 4, 5],
  },
};

export interface BannerData {
  id: number;
  tKey: string;
  image: string;
  title?: string;
  param: string;
  fullParam?: string;
  counter?: number | string;
  counterKey?: MiniBannerCounterKey;
  device?: 'desktop' | 'mobile' | 'both';
  auth?: 'all' | 'authenticated' | 'unauthenticated';
  disabled?: boolean;
  srcActive?: string;
}

export const isBettingBanner = (id: number) =>
  (id >= 20 && id <= 23) || id === 2;

export const sortedMobileMenuButtons = (
  values: number[],
  bettingEnabled: boolean
) => {
  const result: BannerData[] = [];
  for (const id of values) {
    if (!bettingEnabled && isBettingBanner(id)) continue;
    const banner = BANNERS_BY_ID.get(id);
    if (banner) result.push({ ...banner });
  }
  return result;
};

export const getInfoMenu = () => {
  return sortedMobileMenuButtons(
    SORT_CONFIG_BANNERS.navInfoMenu,
    getThemeBrand().features.betting
  );
};
export const getBettingMenu = () => {
  return sortedMobileMenuButtons(
    SORT_CONFIG_BANNERS.navBettingMenu,
    getThemeBrand().features.betting
  );
};
